<h2 mat-dialog-title>Triage Session Conversation</h2>

<mat-dialog-content class="dialog-content">
  <div class="session-meta">
    <p><strong>Session ID:</strong> {{ data.triageSessionId }}</p>
    <p><strong>Total Messages:</strong> {{ data.totalMessages }}</p>
  </div>

  <div class="chat-container">
    @for (message of data.chatHistory; track $index) {
      <div
        class="chat-message"
        [ngClass]="{
          agent: message.role === 'agent' || message.role === 'assistant',
          user: message.role === 'user',
        }"
      >
        <span class="role-label">{{ message.role }}</span>
        <span class="content">{{ getMessageText(message) }}</span>
        @if (getTimestamp(message)) {
          <span class="timestamp">{{
            getTimestamp(message) | date: 'short'
          }}</span>
        }
      </div>
    }

    @if (data.chatHistory.length === 0) {
      <p class="no-messages">No messages found for this triage session.</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
